import type { FaireProductEntity } from "../../entity_types/product";

export const p_18f57pw7fg: FaireProductEntity = {
  token: "p_18f57pw7fg",
  type: "product",
  name: "IMMUNE SUPPORT SALVE | 2 oz",
  brandToken: "b_5dagse75md",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d6e61081833e25366863b0b0cb42d76da4bbf60f48b2f26e827b2c472d0ba1f5.png",
  galleryImageUrls: [],
  priceDollars: 17,
  description:
    'When we or our loved ones get sick, we need something quick, powerful, and effective to instantly fight against outside invaders trying to attack our bodies.\n\nThis immune boosting salve is packed full of oils known for their antiviral, antibacterial, antiseptic, and antifungal qualities. They are great to use reactively or proactively for those struggling to stay healthy.\n\nTO USE: Apply to soles of feet or spine 1–2 times daily.\n\nINGREDIENTS: RAW SHEA BUTTER, ORGANIC RAW UNREFINED COLD PRESSED COCONUT OIL, ORGANIC BEESWAX, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: CLOVE, LEMON, CINNAMON BARK, EUCALYPTUS RADIATA, ROSEMARY, TEA TREE, FRANKINCENSE, THYME, OREGANO, GERANIUM, LEMONGRASS.\n\n*Always check with your doctor before using a new product or supplement if you have any questions or concerns about how a product may affect your current health, medications, pregnancy, or breastfeeding.\n\nDimension: 2 oz, 2.145" x 1.89" x 2.145".',
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:13.585Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
